import { each, filter, remove, toInteger } from 'lodash';
import { ActivityTypeEnum, OffTypeEnum, UsePromoCodeStatusEnum } from '../enum';
import { findActivityProduct, toFixed } from '../lib/utils';
export default function calSingleItemSwapBuy(opt) {
    const { products, singleItemSwapBuyMap, singleItemSwapBuyActivities, parentProductMap, enablePromoCodeActivity } = opt;
    let { usePromoCodeStatus } = opt;
    const childPks = [];
    const allSwapBuyProducts = [];
    let remainingPayment = 0; // 剩余付的钱
    let isOverlySingleItemDiscount = null;
    each(products, (product) => {
        const childId = product.pk || product.productNo + '_' + product.scaleNo;
        if (!product.orderDetailId) {
            each(singleItemSwapBuyActivities, (activity) => {
                var _a, _b, _c, _d;
                const findProduct = findActivityProduct(((_a = activity === null || activity === void 0 ? void 0 : activity.extra) === null || _a === void 0 ? void 0 : _a.triggerProductMap) || {}, product);
                if (findProduct) {
                    const maxSwapCnt = toInteger(((_b = activity.extra) === null || _b === void 0 ? void 0 : _b.maxSwapCnt) || 1);
                    if (!singleItemSwapBuyMap[childId]) {
                        singleItemSwapBuyMap[childId] = {
                            activityProducts: activity.products || [],
                            maxSwapCnt: maxSwapCnt,
                            surplusCnt: maxSwapCnt * (product.cnt || 0),
                            activityName: activity.activityName,
                            validProducts: [],
                        };
                    }
                    const swapBuyProducts = product.swapBuyProducts || [];
                    if (swapBuyProducts.length > 0) {
                        each(swapBuyProducts, (swapBuyProduct) => {
                            var _a;
                            swapBuyProduct.productAndModifierPrice = toFixed(swapBuyProduct.price + (swapBuyProduct.modifierPrice || 0));
                            const findSwapBuyProduct = findActivityProduct(activity.productMap || {}, swapBuyProduct);
                            if (findSwapBuyProduct) {
                                let swapOff = swapBuyProduct.price - findSwapBuyProduct.activityPrice;
                                if (swapOff < 0) {
                                    swapOff = 0;
                                }
                                if (singleItemSwapBuyMap[childId].surplusCnt > 0) {
                                    if (activity.promoCode && usePromoCodeStatus === UsePromoCodeStatusEnum.Unused) {
                                        usePromoCodeStatus = UsePromoCodeStatusEnum.Effective;
                                        enablePromoCodeActivity.push(activity.activityId);
                                    }
                                    remainingPayment += swapBuyProduct.productAndModifierPrice - swapOff;
                                    isOverlySingleItemDiscount = (_a = activity === null || activity === void 0 ? void 0 : activity.extra) === null || _a === void 0 ? void 0 : _a.isOverlySingleItemDiscount;
                                    swapBuyProduct.off = swapOff;
                                    singleItemSwapBuyMap[childId].validProducts.push(Object.assign(Object.assign({}, swapBuyProduct), { off: swapOff, activityPrice: findSwapBuyProduct.activityPrice, offTip: activity.activityName, offId: activity.activityId, offType: activity.promoCode ? OffTypeEnum.PromoCode : OffTypeEnum.Activity }));
                                    singleItemSwapBuyMap[childId].surplusCnt--;
                                }
                            }
                            allSwapBuyProducts.push(swapBuyProduct);
                        });
                    }
                    else {
                        if (activity.promoCode) {
                            enablePromoCodeActivity.push(activity.activityId);
                        }
                    }
                    if (singleItemSwapBuyMap[childId].validProducts.length > 0) {
                        product.isOverlySingleItemDiscount = ((_c = activity.extra) === null || _c === void 0 ? void 0 : _c.isOverlySingleItemDiscount) || false;
                        product.isOverlyDesignatedItemDiscount = ((_d = activity.extra) === null || _d === void 0 ? void 0 : _d.isOverlyDesignatedItemDiscount) || false;
                    }
                }
            });
        }
        else if (product.orderDetailId &&
            product.orderParentId &&
            product.orderParentId != '0' &&
            product.orderDisocuntList &&
            product.orderDisocuntList.length > 0) {
            // 换购物数据固化下来了
            const singleItemSwapBuyDisouncts = filter(product.orderDisocuntList, (orderDisocunt) => {
                if (orderDisocunt.discountType === ActivityTypeEnum.SingleItemSwapBuyPromoCode) {
                    usePromoCodeStatus = UsePromoCodeStatusEnum.Effective;
                    enablePromoCodeActivity.push(orderDisocunt.activityId);
                    return true;
                }
                return orderDisocunt.discountType === ActivityTypeEnum.SingleItemSwapBuy;
            });
            let parentProduct = parentProductMap[product.orderParentId];
            if (!parentProduct && product.orderDetailId && product.orderParentId) {
                parentProduct = {};
            }
            if (singleItemSwapBuyDisouncts && singleItemSwapBuyDisouncts.length > 0 && parentProduct) {
                childPks.push(childId);
                if (!singleItemSwapBuyMap[childId]) {
                    singleItemSwapBuyMap[childId] = {
                        activityProducts: [],
                        maxSwapCnt: 0,
                        surplusCnt: 0,
                        activityName: '',
                        validProducts: [],
                    };
                }
                each(singleItemSwapBuyDisouncts, (singleItemSwapBuyDisounct) => {
                    const activityContentObj = JSON.parse(singleItemSwapBuyDisounct.activityContent || '{}');
                    parentProduct.isOverlySingleItemDiscount = activityContentObj.isOverlySingleItemDiscount || false;
                    parentProduct.isOverlyDesignatedItemDiscount = activityContentObj.isOverlyDesignatedItemDiscount || false;
                    product.isOverlyDesignatedItemDiscount = activityContentObj.isOverlySingleItemDiscount || false;
                    product.isOverlyDesignatedItemDiscount = activityContentObj.isOverlyDesignatedItemDiscount || false;
                    product.productAndModifierPrice = toFixed(product.price + (product.modifierPrice || 0));
                    remainingPayment += product.productAndModifierPrice - singleItemSwapBuyDisounct.fee;
                    singleItemSwapBuyMap[childId].validProducts.push(Object.assign(Object.assign({}, product), { off: singleItemSwapBuyDisounct.fee, offTip: singleItemSwapBuyDisounct.discountName, offId: singleItemSwapBuyDisounct.activityId, offType: OffTypeEnum.Activity }));
                    isOverlySingleItemDiscount = activityContentObj.isOverlySingleItemDiscount;
                });
            }
        }
    });
    remove(products, (product) => childPks.includes(product.pk));
    return { usePromoCodeStatus, allSwapBuyProducts, remainingPayment, isOverlySingleItemDiscount };
}
//# sourceMappingURL=calSingleItemSwapBuy.js.map